import { useEffect } from 'react'
import redirect from 'helpers/redirect'
import { PATH_DASHBOARD } from 'routes/paths'
import LoadingScreen from 'components/LoadingScreen'

function VerificationScreen() {
  useEffect(() => {
    redirect(PATH_DASHBOARD.general.verification.root)
  }, [])

  return <LoadingScreen />
}

export default VerificationScreen
